import styles from './GuidanceCard.scss';
import React, { useContext } from 'react';
import { purchaseDomainRoute } from '../../../helpers/routes';
import { TrackingContext } from '../../../TrackingContext';
import { useHistory } from 'react-router-dom';
import GuidanceLink from './GuidanceLink';
import TextGuidanceCard from './TextGuidanceCard';

const CustomDomainCard = () => {
  const { track } = useContext(TrackingContext);
  const history = useHistory();

  const goToCustomDomainBuy = (e: { preventDefault: () => void }) => {
    track('Custom WWS Domain Modal Opened');
    history.push(purchaseDomainRoute);
    e.preventDefault();
  };

  return (
    <GuidanceLink
      onClick={goToCustomDomainBuy}
      href="/"
      data-testid="promotion-custom-domain-cta"
      aria-disabled="true"
      className={styles.customDomainCard}
    >
      <TextGuidanceCard title="Upgrade your URL" body="Make your website 100% you with a custom domain." />
    </GuidanceLink>
  );
};

export default CustomDomainCard;
